.bolt{color:#765dd8}
/*# sourceMappingURL=polygon-secondary-toolbar.component.css.map */
